import { BasicGrid, Button, Text } from '@104ha/base-ui';
import styled from '@emotion/styled';
import React from 'react';
import { accountStatusCode } from './const';

const Btn: React.FC<{ children: React.ReactNode; onClick?: () => any }> = ({ children, ...props }) => (
	<Button.Normal theme="primary" className="btn-block" {...props}>
		{children}
	</Button.Normal>
);

const BtnGroup = styled.div`
	display: flex;
	margin-bottom: 5px;

	& > * {
		margin-top: 0 !important;
	}
`;

/**
 * 可以透過傳入泛型修改原本的類型：
 * export class _Grid extends BasicGrid<GridProps>
 */

export class Grid extends BasicGrid<
	{
		openEditDialog?: (rowData: any) => any;
		openEditPasswordDialog?: (rowData: any) => any;
		openBrowseDialog?: (rowData: any) => any;
		openEditPrivilageDialog?: (rowData: any) => any;
	},
	{ confirm: any; sortBy: string; sortKey: string; sortOrder: string }
> {
	static defaultProps = {
		...BasicGrid.defaultProps,
		api: '/api/manage/privilege/account/find',
		colWidths: [140, 40, '10', '*', '20', 140],
		fetch: false,
		basicCriteria: {
			kw: {
				label: '帳號名稱',
				input: (
					<Text
						{...{
							width: 120,
							validate: { max: 50 },
						}}
					/>
				),
				fireOnEditing: true,
			},
		},
	};

	renderGridHeader() {
		const { TH } = this;
		return (
			<tr>
				<th></th>
				<TH.seq />
				<TH.sortable sortKey="accountStatus">帳號狀態</TH.sortable>
				<TH.sortable sortKey="userAccount">API登入帳號</TH.sortable>
				<TH.sortable sortKey="userName">帳號名稱</TH.sortable>
				<TH.sortable sortKey="authMode">串接方式</TH.sortable>
				<TH.sortable sortKey="apiNumber">使用API數量</TH.sortable>
				<TH.sortable sortKey="cmpNumber">存取公司</TH.sortable>
			</tr>
		);
	}

	componentDidMount() {
		super.componentDidMount();
		this.setState({
			sortBy: 'accountStatus',
			sortKey: 'accountStatus',
			sortOrder: 'asc',
		});
	}

	deleteHandler = () => {
		new _Ajax({
			url: '/api/manage/privilege/account/delete',
			data: {
				id: this.state.confirm.id,
			},
			successMsg: '刪除帳號完成!',
			errMsg: '刪除帳號失敗',
			onSuccess: () => {
				this.reload();
			},
		}).send();
	};

	renderGridBody(data: any, idx: number) {
		const { TD } = this;
		const { accountStatus, userAccount, userName, apiNumber, cmpNumber, authMode } = data;

		return (
			<>
				<td>
					<BtnGroup>
						<Btn
							onClick={() => {
								this.props.openEditDialog?.(data);
							}}
						>
							編輯
						</Btn>
						<Btn
							onClick={() => {
								this.setState({
									confirm: {
										id: data.id,
										msg: '確定要刪除嗎',
									},
								});
							}}
						>
							刪除
						</Btn>
					</BtnGroup>
					{authMode === 1 ? (
						<Btn
							onClick={() => {
								this.props.openEditPasswordDialog?.(data);
							}}
						>
							變更密碼
						</Btn>
					) : null}
					<Btn
						onClick={() => {
							this.props.openEditPrivilageDialog?.(data);
						}}
					>
						變更權限
					</Btn>
				</td>
				<TD.seq idx={idx} />
				<td>{accountStatusCode[accountStatus]}</td>
				<td>
					<a
						href="/"
						onClick={(e) => {
							e.preventDefault();
							this.props.openBrowseDialog?.({
								...data,
								idx,
							});
						}}
					>
						{userAccount}
					</a>
				</td>
				<td>{userName}</td>
				<td>{authMode === 1 ? 'Token串接模式' : 'API 金鑰模式'}</td>
				<td>{apiNumber}</td>
				<td>{cmpNumber}</td>
			</>
		);
	}
}
